import React, { useState, useRef, useEffect, useContext } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import CreditCoins from "../pages/home/CreditCoins";
import Notification from "../pages/home/Notification";
import SearchFilters from "../pages/home/SearchEvent";
import MyProfile from "../pages/Profiles/MyProfile";
import Container from "react-bootstrap/Container";
// import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Credit_BALANCE, RECURITER_NOTIFICATIONSLOG, Recruiter_Get_Chats, RECURITER_PROFILE, UNLOCKED_PROFILESS } from "../Service/service";
import { getData } from "../Service/ApiMethod";
import { credit_coin, foCredit } from "../App";
import Languageoption from "../translation/language-dropdown";
// import i18next from "i18next"
// import Geocode from "react-geocode";

// import {useTranslation} from 'react-i18next'
import { useTranslation } from "react-i18next";
import UpdateLocation from "./UpdateLocatioPopup";
// import { async } from "react-input-emoji";
import { lang } from "../lang";
const Header = (props) => {
  // const [profile, setProfile] = useState(false);
  // const [anywhere, setAnywhere] = useState(false);
  // const [creditCoins, setCreditCoins] = useState(false);
  const [searchEvent, setSearchEvent] = useState(false);
  // const [resdata, setResData] = useState();
  const [popups, setPopups] = useState(0);
  const [sessionValue, setSessionValue] = useState()
  const [notificationCount, setNotificationCount] = useState()
  const [countChange, setCountChange] = useState(false)
  const [readCount, setReadCount] = useState()
  const [count, setCount] = useState([])
  const [locationPopup, setLocationPopup] = useState(false)
  const [resData, setResData] = useState('');
  const [ln,setLn] = useState('en')
  const callCredit = useContext(foCredit)
  const creditCoinNumber = useContext(credit_coin)
  // console.log('creditCoinNumber12', creditCoinNumber)
  const navigate = useNavigate();
  const ref = useRef(null);
  useOutsideAlerter(ref);
  const searchValue = useRef()
  // const location = useLocation()

  const { t } = useTranslation();
  const handleClick = async (e) => {
    const bodyData = {
      language: e.target.value
    }
    console.log(bodyData, "ssddddddsaa")
    // let token = await localStorage.getItem("catzapp_token");
    // fetch("https://api.catzapp.com/recruiter/languageupdate/", {
    //   method: 'PATCH',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: 'Bearer ' + token,
    //   },
    //   body: JSON.stringify(bodyData),
    // })
    //   .then(res => {
    //     console.log(e.target.value,"ccss")
    //     i18next.changeLanguage(e.target.value)
    //     localStorage.setItem("language",e.target.value)
    //     window.location.reload()
    //   })


  }
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
        setLn(localStorage.getItem("language"))
      } 
  },[])

  function useOutsideAlerter(ref) {
    useEffect(() => {
      console.log("111222222");
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          props?.closeModalWrtOutsideClick();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  // const getDetail = () => {
  //   getData(Credit_BALANCE)
  //     .then((response) => response.json())
  //     .then((res) => {
  //       setResData(res.data?.credit_balance_history[0])
  //     })
  //     .catch((err) => {
  //       console.log("Error ", err);
  //     });
  // };
  // console.log('resdata',resdata);

  const getDetail = () => {
    getData(RECURITER_PROFILE)
      .then((response) => response.json())
      .then((res) => {
        console.log("dddddddddddssssssssss", res.data);
        setResData(res.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });
  };

  useEffect(() => {
    console.log("111222222333");

    getDetail()
  }, [])
  console.log('typeof', resData);


  const getNotificationCount = () => {
    getData(RECURITER_NOTIFICATIONSLOG)
      .then((response) => response.json())
      .then((res) => {
        setNotificationCount(res.data.notification_log?.length)

        console.log('Notification Data', res.data.notification_log?.length)

        let temp = 0;
        if (res.data.notification_log) {
          res.data.notification_log?.map((item, index) => {
            if (!(item?.is_read)) {
              temp += 1
              // console.log('temp', temp)
            } else {
              temp = temp
            }
            return temp
          })
        } else {

        }

        setReadCount(temp)
      })
      .catch((err) => {
        console.log("Error ", err)
      })

  }

  console.log('Read count', readCount)



  useEffect(() => {
    console.log("1112222223334");
    getNotificationCount()
  }, [countChange])






  const MessageCount = () => {

    getData(RECURITER_PROFILE)
      .then((res) => res.json())
      .then((res) => {
        console.log(res?.data, "get message count");
        setCount(res?.data?.unread_count);
      })
  };


  useEffect(() => {
    console.log("1112222223335");
    callCredit()
    MessageCount()
  }, [])



  // function useOutsideAlerter(ref) {
  //   useEffect(() => {
  //     function handleClickOutside(event) {
  //       if (ref.current && !ref.current.contains(event.target)) {
  //         setCreditCoins(false);
  //       }
  //     }

  //     document.addEventListener("mousedown", handleClickOutside);

  //     return () => {
  //       document.removeEventListener("mousedown", handleClickOutside);
  //     };
  //   }, [ref]);
  // }

  const [isActive, setIsActive] = useState(false);
  const getSession = () => {
    const getSessionValue = sessionStorage.getItem('unlocked for credit')
    setSessionValue(getSessionValue)
    console.log('getSessionValue', getSessionValue)
  }
  console.log('getSessionValue', sessionValue)


  useEffect(() => {
    console.log("1112222223335");
    getSession()
    checkShare()
    // getDetail()
  }, [sessionValue])

  useEffect(() => {
    console.log("1112222223336");
    // getDetail();
    getNotificationCount()
  }, [])

  const collapseRef = useRef(null);

  const handleNavCollapse = () => {
    if (collapseRef.current) {
      collapseRef.current.classList.remove('show');
    }
  };

  function handleKeyPress() {
    if (searchValue.current.length > 3) {
      localStorage.setItem("searchValue", searchValue.current)
      navigate('/candidate-search-list')
    }
  }



  const checkShare = async () => {
    let seekerShare_id = await localStorage.getItem("seekershareid")
    if (seekerShare_id != null) {
      // setSeekershare(true)
      let request = {
        "candidate_id": seekerShare_id
      };
      console.log(request, "pdddddddddddddddddddddddddddsssssssssssss", props);

      const url = 'https://api.catzapp.com/recruiter/candidateProfile_v1/';
      const token = await localStorage.getItem("catzapp_token");
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Include your token in the Authorization header
        },
        body: JSON.stringify(request) // Convert the data to JSON string
      };

      fetch(url, requestOptions)
        .then(response => response.json())
        .then(data => {
          // Handle the response data
          console.log(data);

          console.log('8888888888888888888222222222222222', data.data)
          searchValue.current = data.data.first_name + " " + data.data.last_name
          if(searchValue.current){ 
            let byEmail = (data.data.email).toLowerCase()
            console.log(UNLOCKED_PROFILESS + "?pgNo=" + 1 + "&keyword=" + byEmail + "&filter=" + 0,"sddddddddd")
            getData(UNLOCKED_PROFILESS + "?pgNo=" + 1 + "&keyword=" + byEmail + "&filter=" + 0)
            .then((response) => response.json())
            .then((data) => {
              console.log(byEmail,"85555552222",data.data.total_count)
              setTimeout(()=>{
                if(data.data.total_count != 0){
                  if(searchValue.current){
                    alert("Please Check"+ searchValue.current+"Seeker Profile in Ulocked Candidate List")
                  }
                  localStorage.removeItem("seekershareid")
                  setTimeout(()=>{
                    searchValue.current=""
                  },1000)
                 
                }else{
                  setTimeout(() => {
                  localStorage.setItem("searchValue", searchValue.current)
                  navigate('/candidate-search-list')
                  localStorage.removeItem("seekershareid")
                }, 2000)
                }
              },2000)
            
            })
          }
         
              // setSeekerdata(data.data)
              // setTimeout(() => {
              //   localStorage.setItem("searchValue", searchValue.current)
              //   navigate('/candidate-search-list')
              //   localStorage.removeItem("seekershareid")
              // }, 5000)

              // setSingleCandidateData(data.data)
              // handleGetAddress(data.data.latitude, data.data.longitude)
            })
            .catch(error => {
              // Handle any errors
              console.error('Error:', error);
            });
        }
  }

    return (
      <>
        <Navbar bg="dark" className="header-container navbar-dark sticky-top" expand="lg">
          <Container fluid className="navbar-content" style={{
            position: 'unset',
            zIndex: '99999999999999999999999999999'
          }}>
            <Link to="/home"
              className="navbar-brand"
              style={{
                color: "#ffffff",
                fontWeight: "bold",
                fontSize: "30px",
                cursor: 'arrow'

              }}
            >
              <img src="../images/logo-atzapp_white.png" alt="logo" />
            </Link>

            {/* <Form className="d-flex"> */}
            {


            } <span className="location-search"> <div className="loaction-outer" style={{}} onClick={(e) => {
              setLocationPopup(!locationPopup)
            }} >


              <img className="locateimg" src="https://catzapp-dev.s3.eu-central-1.amazonaws.com/white-locations.png" />

            </div>
              {
                locationPopup && <UpdateLocation
                  refresh={props.refresh}
                  setLocationPopup={setLocationPopup} />
              }

              {
                <div
                  className="search-container response-search flex-center relative"
                // onClick={(e) => {
                //   setSearchEvent(!searchEvent);
                // }}
                >
                  <input
                    type="text"
                    disabled={window.location.hash.substring(2) == "candidate-search-list" ? true : false}
                    placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.Home["Search by Candidates/categories/Services"]:""}
                    className="search-input form-control"
                    value={searchValue.current}
                    onChange={(e) => { searchValue.current = e.target.value }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handleKeyPress(e); // Call the function when Enter key is pressed
                      }
                    }}
                  />
                  <div onClick={() => {
                    if (searchValue.current.length > 3) {
                      localStorage.setItem("searchValue", searchValue.current)
                      navigate('/candidate-search-list')
                    }
                  }}>
                    <img src="https://catzapp-dev.s3.eu-central-1.amazonaws.com/search.png" alt="search" />
                  </div>
                </div>
              }</span>

            {searchEvent ? (
              <SearchFilters setSearchEvent={setSearchEvent}
              // closePopup={() => {
              //   setSearchEvent(!searchEvent);
              // }}
              // insideClick={() => setSearchEvent(true)}
              // outsideTouch={() => setSearchEvent(false)}
              />
            ) : null}
            {/* </Form> */}
            {console.log(searchEvent)}
            <div onClick={() => setIsActive(true)}>
              <Navbar.Toggle aria-controls="navbarScroll" onClick={handleNavCollapse}
                aria-expanded={false} />
            </div>
            <Navbar.Collapse id="navbarScroll"
              // style={{marginRight:"-300px"}}
              ref={collapseRef}
            >
              <Nav
                className="me-auto my-2 my-lg-0 ml-auto"
                style={{ maxHeight: "100px" }}
                navbarScroll
              >
                <Link to="/home" className="header-links nav-link ml-0">
                  <img
                    className="mfooter-icons"
                    src="https://catzapp-dev.s3.eu-central-1.amazonaws.com/trending-up.png"
                    alt=""
                  />
                  <p className="text-white menu-label">{t('Home')}</p>
                </Link>
                {/* <Nav.Link href="#action2">Link</Nav.Link> */}

                <Link to="/vaccancy" className="header-links nav-link ml-0">
                  {/* <div className=""> */}
                  <img
                    className="mfooter-icons"
                    src="https://catzapp-dev.s3.eu-central-1.amazonaws.com/vector2.png"
                    alt=""
                    style={{}}
                  />
                  {/* </div> */}
                  <p className="text-white menu-label">{lang && Object.keys(lang).length > 0 ? lang[ln]?.tab['My Vacancies']:""}</p>
                </Link>

                <Link to="/unlock-profiles" className="header-links nav-link">
                  <img
                    className="mfooter-icons"
                    src="https://catzapp-dev.s3.eu-central-1.amazonaws.com/person.png"
                    alt=""
                  />
                  <p className="text-white menu-label">{t('Unlocked Profiles')}</p>
                </Link>
                {/* <Nav.Link className="header-links" > */}
                <Nav.Link className="header-links "
                  style={{ paddingTop: "8px", paddingTop: "8px" }} >
                  <div
                    className="item relative "
                    onClick={() => {
                      setPopups(3);
                    }}
                  >
                    <img
                      src="https://catzapp-dev.s3.eu-central-1.amazonaws.com/credit-coins-icon.png"
                      className="pr-2 img-fluid"
                      alt=""
                    />
                    <div className="mt-2">
                      {/* <h4 className="credit-coins">{resdata?.available_credits}</h4> */}
                      <h4 className="credit-coins">{creditCoinNumber?.available_credits}</h4>
                      {/* <p className="header-text">Credits</p> */}
                      <p className="text-white menu-label"> {t('Credits')}</p>
                    </div>
                  </div>
                </Nav.Link>

                <Link to="/message" className="nav-link header-links"
                // style={{paddingTop:'25px'}}
                >
                  {/* <p className="text header-heading">Messages  </p> */}

                  <div style={{ position: "relative" }}>
                    <img
                      src="https://catzapp-dev.s3.eu-central-1.amazonaws.com/message.png"
                      className="mfooter-icons not-in-lg-header-icon "
                      alt="msg"
                    />
                    {
                      count === 0 ?
                        null : <span className="no_notifi" style={{
                          position: 'absolute',
                          backgroundColor: 'red',
                          top: '-7px',
                          // padding:'2px 3px 3px',
                          left: '6px',
                          color: 'white',
                          // borderRadius:'50%',
                          // fontSize:'10px',
                          // width:'15px',
                          // height:'15px'
                        }}>
                          {/* {notificationCount} */}
                          {count <= 9 ? count : '9+'}

                        </span>
                    }
                  </div>
                  <p className="text-white menu-label not-in-lg-header-text">
                    {lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['Message']:""}
                  </p>

                </Link>
                <Nav.Link className="header-links">
                  <div className="item relative">
                    <button
                      className="btn-none header-links"
                      onClick={() => {

                        setPopups(2);
                      }}
                    >
                      <div style={{ position: 'relative' }}>
                        <img
                          src="https://catzapp-dev.s3.eu-central-1.amazonaws.com/bell.png"
                          className="mfooter-icons not-in-lg-header-icon "
                          style={{ paddingRight: "5px" }}
                          alt="msg"
                        />
                        {
                          readCount !== 0 ? <span className="no_notifi" style={{
                            position: 'absolute',
                            backgroundColor: 'red',
                            top: '-7px',
                            // padding:'2px 3px 3px',
                            left: '6px',
                            color: 'white',
                            // borderRadius:'50%',
                            // fontSize:'10px',
                            // width:'15px',
                            // height:'15px'
                          }}>
                            {/* {notificationCount} */}
                            {readCount <= 9 ? readCount : "9+"}
                          </span> : null
                        }
                      </div>
                      <p className="text-white menu-label not-in-lg-header-text">
                        {t('Notifications')}
                      </p>
                    </button>
                    {popups === 2 ? <Notification setPopups={setPopups} changeCount={setCountChange} countChange={countChange} notificationCountnumber={getNotificationCount} closeModalWrtOutsideClick={() => {
                      setPopups(0)
                      handleNavCollapse()
                    }} crossClose={() => {
                      setPopups(0)
                      handleNavCollapse()
                    }} /> : null}
                  </div>
                </Nav.Link>
                <Nav.Link className="header-links">
                  <div className="col px-0 flex-center relative">
                    <div
                      className="header-links mr-0"
                      onClick={() => {
                        setPopups(1);
                      }}
                    >
                      {/* <div className=""> */}
                      <img
                        className="mfooter-icons"
                        src="https://catzapp-dev.s3.eu-central-1.amazonaws.com/my-profile-icon.png"
                        alt=""
                      />
                      <p className="text-white menu-label">{t('My Profile')}</p>
                      {/* </div> */}
                    </div>
                    {popups === 1 ? <MyProfile
                      resData={resData}
                      closeModalWrtOutsideClick={() => {
                        setPopups(0)
                        handleNavCollapse()
                      }} closePopup={() => {
                        setPopups(0)
                        handleNavCollapse()
                      }} /> : null}
                    {popups === 3 ? <CreditCoins closeModalWrtOutsideClick={() => {
                      setPopups(0)
                      handleNavCollapse()
                    }} upgrade={() => {
                      setPopups(0)
                      handleNavCollapse()
                    }} crossClose={() => {
                      setPopups(0)
                      handleNavCollapse()
                    }} /> : null}
                  </div>

                </Nav.Link>
                <Nav.Link className="header-links">
                  <div className="">
                    <Languageoption onChange={(e) => handleClick(e)} />


                  </div>
                </Nav.Link >
                <div className="close-iconn" id="closeicon"><button type="button" class="close" aria-label="Close" >
                  <span aria-hidden="true">&times;</span>
                </button></div>
              </Nav>
            </Navbar.Collapse>

          </Container>
        </Navbar>
        {/* <div className="header-container space-between d-flex">
        <div className="flex-center">
          <p
            style={{
              color: "#ffffff",
              marginLeft: "40px",
              fontWeight: "bold",
              fontSize: "30px",
            }}
          >
            LOGO
          </p>
          <div
            className="search-container flex-center relative ml-3"
            onClick={() => {
              setSearchEvent(!searchEvent);
            }}
          > 
            <input
              type="text"
              placeholder="Search by Candidates/categories/Services"
              className="search-input"
            />
            <img src="./images/search.png" alt="search" />
          </div>
          {searchEvent ? (
            <SearchFilters
              closePopup={() => {
                setSearchEvent(!searchEvent);
              }}
            />
          ) : null}
        </div>
        <div className="d-flex">
          <div className="col px-0 flex-center">
            <Link to="/home" className="header-links">
              <img
                className="mfooter-icons"
                src="./images/trending-up.png"
                alt=""
              />
              <p className="text-white menu-label">Home</p>
            </Link>
          </div>
          <div className="col px-0 flex-center">
            <Link to="/vaccancy" className="header-links">
              <img
                className="mfooter-icons"
                src="./images/Vector.png"
                alt=""
                style={{ width: "30px" }}
              />
              <p className="text-white menu-label">My vaccancies</p>
            </Link>
          </div>
          <div className="col px-0 flex-center">
          <div className="post-footer">
            <img
              className="img-70"
              src="./images/postPlus.png"
              alt=""
            />
            <p className="text-white mt-n2">Post</p>
          </div>
        </div>
          <div className="col px-0 flex-center">
            <Link to="/unlock-profiles" className="header-links">
              <img className="mfooter-icons" src="./images/person.png" alt="" />
              <p className="text-white menu-label">Unlocked Profiles</p>
            </Link>
          </div>
          <div
            className="item row relative"
            onClick={() => {
              setCreditCoins(!creditCoins);
            }}
          >
            <img
              src="./images/credit-coins-icon.png"
              className="col px-0"
              alt=""
            />
            <div className="col px-0">
              <h4 className="credit-coins">200</h4>
              <div className="header-text">Credits</div>
            </div>
          </div>
          <div className="item">
            <Link to="/message">
              <p className="text header-heading">Messages  </p>
              <img src="./images/message.png" alt="msg" />
            </Link>
          </div>
          <div className="item relative">
            <button
              className="btn-none"
              onClick={() => {
                setNotification(!notification);
              }}
            >
              <p className="text header-heading">Notification  </p>
              <img src="./images/bell.png" alt="msg" />
            </button>
            {notification ? <Notification /> : null}
          </div>

          <div className="col px-0 flex-center relative">
            <div
              className="header-links"
              onClick={() => {
                setProfile(!profile);
              }}
            >
              <img
                className="mfooter-icons"
                src="./images/my-profile-icon.png"
                alt=""
              />
              <p className="text-white menu-label">My Profile</p>
            </div>
            {profile ? <MyProfile /> : null}
            {creditCoins ? <CreditCoins /> : null}
          </div>
        </div>
      </div> */}
      </>
    );
  };

  export default Header;
